import React, { useEffect, useState, useRef } from "react";
import axiosInstance from '../axiosInstance';
import { useParams, useNavigate, } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaArrowCircleDown, FaCheckCircle, FaQuestionCircle, FaPen, FaLock, FaPlus, FaSearch, FaSortDown, FaSortUp, FaFilter, FaTrash } from 'react-icons/fa';
import { FiArrowLeft } from "react-icons/fi";
import { API_URL_All } from "../api";
import * as general from '../libs/general';
import AdLayout from '../components/AdLayout';
import FeeEditor from '../components/orders/FeeEditor';
import Fee4Editor from '../components/orders/Fee4Editor';
import PriceTypeEditor from '../components/orders/PriceTypeEditor';
import { fetchPartnerMenuPermissions } from "../libs/customerCreatePermission";

const API_URL = `${API_URL_All}/api/users`; // API URL khách hàng

const Contact = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [model, setModel] = useState({});
  const [feeEditorData, setfeeEditorData] = useState(null);
  const [fee4EditorData, setfee4EditorData] = useState(null);
  const [priceTypeData, setPriceTypeData] = useState(null);
  const [partnerFeaturePerm, setPartnerFeaturePerm] = useState({
    loaded: false,
    canView: false,
    canCreate: false,
    canEdit: false,
    canDelete: false,
  });
  const [partnerAccess, setPartnerAccess] = useState("allowed");


  useEffect(() => {
    let cancelled = false;
    const isNewContact = !(id && Number(id) > 0);
    setPartnerFeaturePerm({
      loaded: false,
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    });
    setPartnerAccess("allowed");

    (async () => {
      const p = await fetchPartnerMenuPermissions(axiosInstance);
      if (cancelled) return;
      setPartnerFeaturePerm({
        loaded: true,
        canView: Boolean(p.canView),
        canCreate: Boolean(p.canCreate),
        canEdit: Boolean(p.canEdit),
        canDelete: Boolean(p.canDelete),
      });

      if (isNewContact && !p.canCreate) {
        setPartnerAccess("denied");
        return;
      }
      if (!isNewContact && !(p.canView || p.canEdit)) {
        setPartnerAccess("denied");
        return;
      }
      fetchContact(id);
    })();

    return () => {
      cancelled = true;
    };
  }, [id]);
  const fetchContact = async (id) => {
    try {
      if (!id) id = 0;
      var requestApi = `/api/contacts/getContact?id=${id}`;
      const response = await axiosInstance.get(requestApi);
      var lineItems = response.data.data.lines.split(';');

      setModel({ ...response.data.data, lineItems: lineItems });
      // console.log(response.data.data);

      window.initializeFilterValue({ lines: response.data.data.lines });
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    }
  };

  const openFeeEditor = (params) => {
    if (!formWritable) return;
    //modalRef.current?.showModal(params);
    setfeeEditorData(params);
  };
  const openFee4Editor = (params) => {
    if (!formWritable) return;
    //modal4Ref.current?.showModal(params);
    setfee4EditorData(params);
  };

  const searchFees = async (filter) => {
    fetchContact(model.id);
  };

  const openPriceTypeEditor = (params) => {
    if (!formWritable) return;
    setPriceTypeData(params);
  };
  const handleSubmitForm = async (e) => {
    e.preventDefault();
    const isNewContact = !(id && Number(id) > 0);
    const canSubmitWrite =
      partnerFeaturePerm.loaded &&
      (isNewContact ? partnerFeaturePerm.canCreate : partnerFeaturePerm.canEdit);
    if (!canSubmitWrite) {
      toast.warning("Bạn không có quyền cập nhật.");
      return;
    }
    var errorTag = e.currentTarget.querySelector('.error-msg');
    if (errorTag) return;

    var formData = general.getFormData('#form_contact');
    var dataModel = { ...model };
    dataModel.lines = formData.lines;

    try {
      var requestApi = `/api/contacts/saveContact`;
      const response = await axiosInstance.post(requestApi, dataModel);
      if (!response.data.success) {
        general.showFormError('.form_validate', response.data);
        console.log(response.data);
        return;
      }
      console.log(response);
      toast.success(response.data.message);
      fetchContact(response.data.data);

    } catch (error) {
      toast.error(error.message);
    }

  };

  const handlePriceTypeChange = (contactId, lineId, priceTypeId) => {
    if (!formWritable) return;
    console.log(priceTypeId);

    const payload = {
      id: priceTypeId,
      contactId: contactId,
      lineId: lineId,
    };
    axiosInstance.post('/api/contacts/setDefaultPriceType', payload)
      .then(response => {
        toast.success(response.data.message);
        fetchContact(contactId);
      })
      .catch(error => {
        toast.error(error.message);
      });
  };

  const getLinePriceTypes = (lineId) => {
    return (model.priceTypes ?? []).filter((item) => item.lineId === lineId);
  };

  const getDefaultPriceTypeId = (lineId) => {
    const defaultPriceType = getLinePriceTypes(lineId).find((item) => item.isDefault);
    return defaultPriceType?.id ?? null;
  };

  const isLineDefaultPriceType = (lineId, priceTypeId = null) => {
    return getDefaultPriceTypeId(lineId) === priceTypeId;
  };

  const handleDeleteContact = () => {
    if (!partnerFeaturePerm.canDelete || !(model.id && Number(model.id) > 0)) return;
    const label = String(model.code || model.name || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
    general.openConfirm(async () => {
      try {
        const response = await axiosInstance.post(`/api/contacts/deleteContact/${model.id}`, {});
        if (!response.data?.success) {
          toast.error(response.data?.message || "Xóa đối tác thất bại");
          return;
        }
        toast.success(response.data.message || "Đã xóa đối tác");
        navigate("/contacts");
      } catch (error) {
        toast.error(error.response?.data?.message || error.message);
      }
    }, `Bạn có chắc chắn muốn xóa đối tác ${label}?`);
  };

  const handleDeleteFee = (feeId) => {
    if (!formWritable) return;
    general.openConfirm(async () => {
      try {
        const response = await axiosInstance.post(`/api/contacts/deleteContactFee/${feeId}`, {});
        toast.success(response.data.message);
        fetchContact(model.id);
      } catch (error) {
        console.error(error);
        toast.error(error.response?.data?.message || error.response?.data || error.message);
      }
    }, "Bạn có chắc chắn muốn xóa mức phí này không?");
  };

  const renderFeeActions = ({ itemId, no, vat = false }) => (
    !formWritable ? null :
    <div className="d-flex align-items-center justify-content-center">
      <button className="px-1 py-0 btn" onClick={() => vat ? openFee4Editor({ id: itemId, no }) : openFeeEditor({ id: itemId, no })}>
        <FaPen className="text-primary" size={12} />
      </button>
      <button className="px-1 py-0 btn" onClick={() => handleDeleteFee(itemId)}>
        <FaTrash className="text-danger" size={12} />
      </button>
    </div>
  );


  const isNewContact = !(id && Number(id) > 0);
  const formWritable =
    partnerFeaturePerm.loaded &&
    (isNewContact ? partnerFeaturePerm.canCreate : partnerFeaturePerm.canEdit);

  useEffect(() => {
    const form = document.querySelector("#form_contact");
    if (!form) return;
    const controls = form.querySelectorAll("input[type='text'], input[type='number'], textarea");
    controls.forEach((el) => {
      el.readOnly = !formWritable;
    });
  }, [formWritable, model.id]);

  if (partnerAccess === "denied") {
    return (
      <div>
        <AdLayout>
          <div className="container py-4">
            <div className="alert alert-warning mb-0">Truy cập không được phép.</div>
          </div>
        </AdLayout>
      </div>
    );
  }

  return (
    <div>
      <AdLayout>

        <div className="mt-2 container normal-form">
          <div className="card shadow-lg1 mb-3">

            <div className="block-header mb-2 position-relative">
              {model.id && (<span className="record_id">ID: {model.id}</span>)}
              <div className="department-page-header">
                <button
                  type="button"
                  className="department-page-header__back"
                  onClick={() => navigate(-1)}
                  aria-label="Quay lại"
                  title="Quay lại"
                >
                  <FiArrowLeft size={18} />
                </button>
                <div>{model.id ? 'Thông tin đối tác' : 'Đối tác mới'}</div>
              </div>
            </div>
            <form id="form_contact" className="form_validate" autoComplete="off" onSubmit={handleSubmitForm}>

              <div className="container">
                <input type="hidden" name="lines" value={model.lines} />
                <input type="hidden" name="contactId" value={model.id} />
                <h5></h5>
                <div className="row">
                  <div className="col-md-6 form-item">
                    <div className="row">
                      <label className="form-label col-form-label col-sm-4 col-4"><span className="required">Tên đối tác</span></label>
                      <div className="col-sm-8 col-8"><input name="name" placeholder="Tên đối tác" type="text" className="form-control" readOnly={!formWritable} data-required="Phải nhập mục này" value={model.name} onChange={(e) => setModel({ ...model, name: e.target.value })} /></div>
                    </div>
                  </div>
                  <div className="col-md-6 form-item">
                    <div className="row">
                      <label className="form-label col-form-label col-sm-4 col-4">Mã đối tác</label>
                      <div className="col-sm-8 col-8"><input name="code" placeholder="Mã đối tác" type="text" className="form-control" readOnly={!formWritable} value={model.code} onChange={(e) => setModel({ ...model, code: e.target.value })} /></div>
                    </div>
                  </div>
                  <div className="col-md-6 form-item">
                    <div className="row">
                      <label className="form-label col-form-label col-sm-4  col-4">MST</label>
                      <div className="col-sm-8  col-8"><input name="name" placeholder="MST" type="text" className="form-control" readOnly={!formWritable} value={model.taxCode} onChange={(e) => setModel({ ...model, taxCode: e.target.value })} /></div>
                    </div>
                  </div>
                  <div className="col-md-6 form-item">
                    <div className="row">
                      <label className="form-label col-form-label col-sm-4  col-4">Điện thoại</label>
                      <div className="col-sm-8  col-8"><input name="name" placeholder="Điện thoại" type="text" className="form-control" readOnly={!formWritable} value={model.phone} onChange={(e) => setModel({ ...model, phone: e.target.value })} /></div>
                    </div>
                  </div>
                  <div className="col-md-6 form-item">
                    <div className="row">
                      <label className="form-label col-form-label col-sm-4  col-4">Tài khoản công ty</label>
                      <div className="col-sm-8  col-8"><input name="name" placeholder="Tài khoản công ty" type="text" className="form-control" readOnly={!formWritable} value={model.companyBank} onChange={(e) => setModel({ ...model, companyBank: e.target.value })} /></div>
                    </div>
                  </div>
                  <div className="col-md-6 form-item">
                    <div className="row">
                      <label className="form-label col-form-label col-sm-4  col-4">Tài khoản cá nhân</label>
                      <div className="col-sm-8  col-8"><input name="name" placeholder="Tài khoản cá nhân" type="text" className="form-control" readOnly={!formWritable} value={model.personalBank} onChange={(e) => setModel({ ...model, personalBank: e.target.value })} /></div>
                    </div>
                  </div>
                  <div className="col-md-6 form-item">
                    <div className="row">
                      <label className="form-label col-form-label col-sm-4 col-4">Đại chỉ VP</label>
                      <div className="col-sm-8 col-8"><input name="name" placeholder="Địa chỉ văn phòng" type="text" className="form-control" readOnly={!formWritable} value={model.address} onChange={(e) => setModel({ ...model, address: e.target.value })} /></div>
                    </div>
                  </div>

                  <div className="col-md-6 form-item">
                    <div className="row">
                      <label className="form-label col-form-label col-sm-4 col-4">Lines</label>
                      <div className="col-sm-8 col-8 ">
                        <div className="th select3">
                          {model.lineItems1 && model.lineItems1.map((item, index) => (
                            <span className="select3-item" key={index}>{item}</span>
                          ))}
                          <span className="filter-ib" data-filter="lines" data-source-key="list_lines"><input type="text" className="form-control" readOnly={!formWritable} placeholder="Tên line" /></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div className="row">
                  <div className="col-md-6 form-item">
                    <div className="row">
                      <label className="form-label col-form-label col-sm-4 col-4">Website</label>
                      <div className="col-sm-8 col-8"><input name="name" placeholder="Website" type="text" className="form-control" readOnly={!formWritable} value={model.website} onChange={(e) => setModel({ ...model, website: e.target.value })} /></div>
                    </div>
                  </div>
                  <div className="col-md-6 form-item">
                    <div className="row">
                      <label className="form-label col-form-label col-sm-4 col-4">Fanpage</label>
                      <div className="col-sm-8 col-8"><input name="name" placeholder="Fanpage" type="text" className="form-control" readOnly={!formWritable} value={model.fanpage} onChange={(e) => setModel({ ...model, fanpage: e.target.value })} /></div>
                    </div>
                  </div>
                </div>


                <div className="row">
                  <div className="col-md-12 form-item">
                    <div className="row">
                      <label className="form-label col-form-label col-sm-2 col-4 col-max174">Chính sách đối tác</label>
                      <div className="col-sm-10 col-8"><textarea name="name" placeholder="Chính sách đền bù & mặt hàng không hỗ trợ" type="text" className="form-control" readOnly={!formWritable} value={model.description} onChange={(e) => setModel({ ...model, description: e.target.value })}></textarea></div>
                    </div>
                  </div>
                </div>

                <div className="row d-none">
                  <div className="col-md-12 form-item">
                    <div className="row">
                      <label className="form-label col-form-label col-sm-2 col-4 col-max174">Bảng giá phụ</label>
                      <div className="col-sm-10 col-8">


                        <div className=" mb-2">
                          <div className="row">
                            <div className="col-12">
                              {model.id > 0 && (

                                <div className="group-box p-2" data-text="Danh sách bảng giá phụ">

                                  <table className="table table-striped table-hover table-bordered">

                                    <thead className="table-primary">
                                      <tr>
                                        <th width="50px">STT</th>
                                        <th><span data-note="">Tên bảng giá phụ</span></th>
                                        <th><span data-note="">Chi tiết</span></th>
                                        <th width="50px">
                                          <a onClick={() => openPriceTypeEditor({ contactId: model.id, no: model.priceTypes.length + 1 })}><FaPlus /></a>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {model.priceTypes && model.priceTypes.map((item, index) => (
                                        <tr key={item.id}>
                                          <td>{index + 1}</td>
                                          <td className="text-start">{item.name}</td>
                                          <td className="text-start">{item.note}</td>
                                          <td>
                                            <a className="" onClick={() => openPriceTypeEditor({ id: item.id, no: index + 1 })}> <FaPen className="text-primary" size={15} /></a>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>

                                </div>
                              )}
                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-center">
                  {formWritable && (
                    <button type="submit" className="btn btn-sm btn-success m-2">
                      Lưu đối tác
                    </button>
                  )}
                  {!isNewContact && partnerFeaturePerm.canDelete && (
                    <button type="button" className="btn btn-sm btn-danger m-2" onClick={handleDeleteContact}>
                      Xóa đối tác
                    </button>
                  )}
                </div>
              </div>
            </form>
            <div>
              <section className="border-bottom p-2 reset-table">
                <div className="container">
                  {/*1:Ecommerce*/}
                  {model.lineIds && model.lineIds.includes(1) && (

                    <div className="row">
                      <div className="col-md-6">
                        <div className=" mt-4">
                          <div className="row">
                            <div className="col-12">
                              <div className="group-box p-2" data-text="Line thương mại điện tử: Hàng nặng">
                                <div className="subtitle bg-01 d-flex justify-content-between align-items-center">
                                  <span className="">Bảng giá phổ thông</span>
                                  <input type="radio" name="ecommercePriceType" checked={isLineDefaultPriceType(1, null)} onChange={() => handlePriceTypeChange(model.id, 1, null)} />
                                </div>
                                <table className="table table-striped table-hover table-bordered">

                                  <thead className="table-primary">
                                    <tr>
                                      <th width="50px">STT</th>
                                      <th><span data-note="KG">Khoảng</span></th>
                                      <th><span data-note="VNĐ">Giá</span></th>
                                      <th width="50px">
                                        <a onClick={() => openFeeEditor({ contactId: model.id, lineId: 1, type: 'kg', no: model.ecommerceWeightFees.filter(item => !item.priceTypeId).length + 1 })}><FaPlus /></a>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {model.ecommerceWeightFees && model.ecommerceWeightFees.filter(item => !item.priceTypeId).map((item, index) => (
                                      <tr key={item.id}>
                                        <td>{index + 1 }</td>
                                        <td>{item.start}-{item.end}</td>
                                        <td>{item?.fee?.toLocaleString("vi-VN")}</td>
                                        <td>{renderFeeActions({ itemId: item.id, no: index + 1 })}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>

                                <div className="sub-price">
                                  {model.priceTypes && model.priceTypes.filter(item => item.lineId === 1).map((priceType, index) => (
                                    <div key={priceType.id}>
                                      <div className="subtitle d-flex justify-content-between align-items-center">
                                        <span>{priceType.name}</span>
                                        <div className="d-flex align-items-center">
                                          <button className="px-1 py-0 btn " onClick={() => openPriceTypeEditor({ id: priceType.id, no: index + 1 })}>
                                            <FaPen className="text-primary" size={10} />
                                          </button>
                                          <input type="radio" name="ecommercePriceType" checked={isLineDefaultPriceType(1, priceType.id)} onChange={() => handlePriceTypeChange(model.id, 1, priceType.id)} />
                                        </div>
                                      </div>
                                      <table className="table table-hover table-bordered">
                                        <thead className="table-primary">
                                          <tr>
                                            <th width="50px">STT</th>
                                            <th><span data-note="KG">Khoảng</span></th>
                                            <th><span data-note="VNĐ">Giá</span></th>
                                            <th width="50px">
                                              <a onClick={() => openFeeEditor({ contactId: model.id, lineId: 1, type: 'kg', priceTypeId: priceType.id, no: model.ecommerceWeightFees.filter(item => item.priceTypeId === priceType.id).length + 1 })}><FaPlus /></a>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {model.ecommerceWeightFees && model.ecommerceWeightFees.filter(item => item.priceTypeId === priceType.id).map((item, index) => (
                                            <tr key={item.id}>
                                              <td>{index + 1}</td>
                                              <td>{item.start}-{item.end}</td>
                                              <td>{item?.fee?.toLocaleString("vi-VN")}</td>
                                              <td>{renderFeeActions({ itemId: item.id, no: index + 1 })}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  ))}
                                </div>


                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mt-4">
                          <div className="row">
                            <div className="col-12">
                              <div className="group-box p-2" data-text="Line thương mại điện tử: Hàng cồng kềnh">
                                <div className="subtitle bg-01">Bảng giá phổ thông</div>
                                <table className="table table-striped table-hover table-bordered">
                                  <thead className="table-primary">
                                    <tr>
                                      <th width="50px">STT</th>
                                      <th><span data-note="M3">Khoảng</span></th>
                                      <th><span data-note="VNĐ">Giá</span></th>
                                      <th width="50px">
                                        <a onClick={() => openFeeEditor({ contactId: model.id, lineId: 1, type: 'm3', no: model.ecommerceSizeFees.filter(item => !item.priceTypeId).length + 1 })}><FaPlus /></a>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {model.ecommerceSizeFees && model.ecommerceSizeFees.filter(item => !item.priceTypeId).map((item, index) => (
                                      <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td>{item.start}-{item.end}</td>
                                        <td>{item?.fee?.toLocaleString("vi-VN")}</td>
                                        <td>{renderFeeActions({ itemId: item.id, no: index + 1 })}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>

                                <div className="sub-price">
                                  {model.priceTypes && model.priceTypes.filter(item => item.lineId === 1).map((priceType, index) => (
                                    <div key={priceType.id}>
                                      <div className="subtitle">{priceType.name} <a className="link" onClick={() => openPriceTypeEditor({ id: priceType.id, no: index + 1 })}>...</a></div>
                                      <table className="table table-hover table-bordered">
                                        <thead className="table-primary">
                                          <tr>
                                            <th width="50px">STT</th>
                                            <th><span data-note="M3">Khoảng</span></th>
                                            <th><span data-note="VNĐ">Giá</span></th>
                                            <th width="50px">
                                              <a onClick={() => openFeeEditor({ contactId: model.id, lineId: 1, type: 'm3', priceTypeId: priceType.id, no: model.ecommerceSizeFees.filter(item => item.priceTypeId === priceType.id).length + 1 })}><FaPlus /></a>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {model.ecommerceSizeFees && model.ecommerceSizeFees.filter(item => item.priceTypeId === priceType.id).map((item, index) => (
                                            <tr key={item.id}>
                                              <td>{index + 1}</td>
                                              <td>{item.start}-{item.end}</td>
                                              <td>{item?.fee?.toLocaleString("vi-VN")}</td>
                                              <td>{renderFeeActions({ itemId: item.id, no: index + 1 })}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  ))}
                                </div>


                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-12 mb-2">
                              {formWritable && (
                                <button type="button" className="small-btn" onClick={() => openPriceTypeEditor({ contactId: model.id, lineId: 1, no: getLinePriceTypes(1).length + 1 })}>Thêm bảng giá: TMĐT</button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 form-item">

                        <div className="row mb-2">
                          <label className="form-label col-form-label col-sm-2 col-4 col-max174"><span data-note="Kg">Cân nặng tối thiểu TMĐT</span></label>
                          <div className="col-sm-2 col-8"><input name="name" placeholder="..." type="number" className="form-control" value={model.minWeightEcommerce} onChange={(e) => setModel({ ...model, minWeightEcommerce: e.target.value })} /></div>
                        </div>
                        <div className="row mb-2">
                          <label className="form-label col-form-label col-sm-2 col-4 col-max174">Địa chỉ kho TMĐT</label>
                          <div className="col-sm-10 col-8"><textarea name="name" placeholder="Địa chỉ kho" type="text" className="form-control" value={model.addressEcommerce} onChange={(e) => setModel({ ...model, addressEcommerce: e.target.value })} ></textarea></div>
                        </div>
                        <div className="row">
                          <label className="form-label col-form-label col-sm-2 col-4 col-max174">Chính sách line TMĐT</label>
                          <div className="col-sm-10 col-8"><textarea name="name" placeholder="Chính sách đền bù & mặt hàng không hỗ trợ" type="text" className="form-control" value={model.policyEcommerce} onChange={(e) => setModel({ ...model, policyEcommerce: e.target.value })}></textarea></div>
                        </div>
                      </div>

                    </div>
                  )}
                  {/*4:Line thương*/}
                  {model.lineIds && model.lineIds.includes(4) && (

                    <div className="row">
                      <div className="col-md-6">
                        <div className=" mt-4">
                          <div className="row">
                            <div className="col-12">
                              <div className="group-box p-2" data-text="Line Thường: Hàng nặng">
                                <div className="subtitle bg-01 d-flex justify-content-between align-items-center">
                                  <span>Bảng giá phổ thông</span>
                                  <input type="radio" name="economyPriceType" checked={isLineDefaultPriceType(4, null)} onChange={() => handlePriceTypeChange(model.id, 4, null)} />
                                </div>
                                <table className="table table-striped table-hover table-bordered">
                                  <thead className="table-primary">
                                    <tr>
                                      <th width="50px">STT</th>
                                      <th><span data-note="KG">Khoảng</span></th>
                                      <th><span data-note="VNĐ">Giá</span></th>
                                      <th width="50px">
                                        <a onClick={() => openFeeEditor({ contactId: model.id, lineId: 4, type: 'kg', no: model.economyWeightFees.filter(item => !item.priceTypeId).length + 1 })}><FaPlus /></a>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {model.economyWeightFees && model.economyWeightFees.filter(item => !item.priceTypeId).map((item, index) => (
                                      <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td>{item.start}-{item.end}</td>
                                        <td>{item?.fee?.toLocaleString("vi-VN")}</td>
                                        <td>{renderFeeActions({ itemId: item.id, no: index + 1 })}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>


                                <div className="sub-price">
                                  {model.priceTypes && model.priceTypes.filter(item => item.lineId === 4).map((priceType, index) => (
                                    <div key={priceType.id}>
                                      <div className="subtitle d-flex justify-content-between align-items-center">
                                        <span>{priceType.name}</span>
                                        <div className="d-flex align-items-center">
                                          <button className="px-1 py-0 btn" onClick={() => openPriceTypeEditor({ id: priceType.id, no: index + 1 })}>
                                            <FaPen className="text-primary" size={10} />
                                          </button>
                                          <input type="radio" name="economyPriceType" checked={isLineDefaultPriceType(4, priceType.id)} onChange={() => handlePriceTypeChange(model.id, 4, priceType.id)} />
                                        </div>
                                      </div>
                                      <table className="table table-hover table-bordered">
                                        <thead className="table-primary">
                                          <tr>
                                            <th width="50px">STT</th>
                                            <th><span data-note="KG">Khoảng</span></th>
                                            <th><span data-note="VNĐ">Giá</span></th>
                                            <th width="50px">
                                              <a onClick={() => openFeeEditor({ contactId: model.id, lineId: 4, type: 'kg', priceTypeId: priceType.id, no: model.economyWeightFees.filter(item => item.priceTypeId === priceType.id).length + 1 })}><FaPlus /></a>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {model.economyWeightFees && model.economyWeightFees.filter(item => item.priceTypeId === priceType.id).map((item, index) => (
                                            <tr key={item.id}>
                                              <td>{index + 1}</td>
                                              <td>{item.start}-{item.end}</td>
                                              <td>{item?.fee?.toLocaleString("vi-VN")}</td>
                                              <td>{renderFeeActions({ itemId: item.id, no: index + 1 })}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  ))}
                                </div>


                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className=" mt-4">
                          <div className="row">
                            <div className="col-12">
                              <div className="group-box p-2" data-text="Line Thường: Hàng cồng kềnh">
                                <div className="subtitle bg-01">Bảng giá phổ thông</div>
                                <table className="table table-striped table-hover table-bordered">

                                  <thead className="table-primary">
                                    <tr>
                                      <th width="50px">STT</th>
                                      <th><span data-note="M3">Khoảng</span></th>
                                      <th><span data-note="VNĐ">Giá</span></th>
                                      <th width="50px">
                                        <a onClick={() => openFeeEditor({ contactId: model.id, lineId: 4, type: 'm3', no: model.economySizeFees.filter(item => !item.priceTypeId).length + 1 })}><FaPlus /></a>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {model.economySizeFees && model.economySizeFees.filter(item => !item.priceTypeId).map((item, index) => (
                                      <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td>{item.start}-{item.end}</td>
                                        <td>{item?.fee?.toLocaleString("vi-VN")}</td>
                                        <td>{renderFeeActions({ itemId: item.id, no: index + 1 })}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>

                                <div className="sub-price">
                                  {model.priceTypes && model.priceTypes.filter(item => item.lineId === 4).map((priceType, index) => (
                                    <div key={priceType.id}>
                                      <div className="subtitle">{priceType.name} <a className="link" onClick={() => openPriceTypeEditor({ id: priceType.id, no: index + 1 })}>...</a></div>
                                      <table className="table table-hover table-bordered">
                                        <thead className="table-primary">
                                          <tr>
                                            <th width="50px">STT</th>
                                            <th><span data-note="M3">Khoảng</span></th>
                                            <th><span data-note="VNĐ">Giá</span></th>
                                            <th width="50px">
                                              <a onClick={() => openFeeEditor({ contactId: model.id, lineId: 4, type: 'm3', priceTypeId: priceType.id, no: model.economySizeFees.filter(item => item.priceTypeId === priceType.id).length + 1 })}><FaPlus /></a>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {model.economySizeFees && model.economySizeFees.filter(item => item.priceTypeId === priceType.id).map((item, index) => (
                                            <tr key={item.id}>
                                              <td>{index + 1}</td>
                                              <td>{item.start}-{item.end}</td>
                                              <td>{item?.fee?.toLocaleString("vi-VN")}</td>
                                              <td>{renderFeeActions({ itemId: item.id, no: index + 1 })}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  ))}
                                </div>

                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12 mb-2">
                              {formWritable && (
                                <button type="button" className="small-btn" onClick={() => openPriceTypeEditor({ contactId: model.id, lineId: 4, no: getLinePriceTypes(4).length + 1 })}>Thêm bảng giá: Line thường</button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>


                      <div className="col-md-12 form-item">
                        <div className="row mb-2">
                          <label className="form-label col-form-label col-sm-2 col-4 col-max174"><span data-note="Kg">Tối thiểu line thường</span></label>
                          <div className="col-sm-2 col-8"><input name="name" placeholder="..." type="number" className="form-control" value={model.minWeightEconomy} onChange={(e) => setModel({ ...model, minWeightEconomy: e.target.value })} /></div>
                        </div>
                        <div className="row mb-2">
                          <label className="form-label col-form-label col-sm-2 col-4 col-max174">Địa chỉ kho line thường</label>
                          <div className="col-sm-10 col-8"><textarea name="name" placeholder="Địa chỉ kho" type="text" className="form-control" value={model.addressEconomy} onChange={(e) => setModel({ ...model, addressEconomy: e.target.value })} ></textarea></div>
                        </div>
                        <div className="row">
                          <label className="form-label col-form-label col-sm-2 col-4 col-max174">Chính sách line thường</label>
                          <div className="col-sm-10 col-8"><textarea name="name" placeholder="Chính sách đền bù & mặt hàng không hỗ trợ" type="text" className="form-control" value={model.policyEconomy} onChange={(e) => setModel({ ...model, policyEconomy: e.target.value })}></textarea></div>
                        </div>
                      </div>

                    </div>
                  )}
                  {/*11:Handheld*/}
                  {model.lineIds && model.lineIds.includes(11) && (
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mt-4">
                          <div className="row">
                            <div className="col-12">
                              <div className="group-box p-2" data-text="Line sách tay: Hàng nặng">
                                <div className="subtitle bg-01 d-flex justify-content-between align-items-center">
                                  <span>Bảng giá phổ thông</span>
                                  <input type="radio" name="handheldPriceType" checked={isLineDefaultPriceType(11, null)} onChange={() => handlePriceTypeChange(model.id, 11, null)} />
                                </div>
                                <table className="table table-striped table-hover table-bordered">

                                  <thead className="table-primary">
                                    <tr>
                                      <th width="50px">STT</th>
                                      <th><span data-note="KG">Khoảng</span></th>
                                      <th><span data-note="VNĐ">Giá</span></th>
                                      <th width="50px">
                                        <a onClick={() => openFeeEditor({ contactId: model.id, lineId: 11, type: 'kg', no: model.handheldWeightFees.filter(item => !item.priceTypeId).length + 1 })}><FaPlus /></a>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {model.handheldWeightFees && model.handheldWeightFees.filter(item => !item.priceTypeId).map((item, index) => (
                                      <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td>{item.start}-{item.end}</td>
                                        <td>{item?.fee?.toLocaleString("vi-VN")}</td>
                                        <td>{renderFeeActions({ itemId: item.id, no: index + 1 })}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>

                                <div className="sub-price">
                                  {model.priceTypes && model.priceTypes.filter(item => item.lineId === 11).map((priceType, index) => (
                                    <div key={priceType.id}>
                                      <div className="subtitle d-flex justify-content-between align-items-center">
                                        <span>{priceType.name}</span>
                                        <div className="d-flex align-items-center">
                                          <button className="px-1 py-0 btn" onClick={() => openPriceTypeEditor({ id: priceType.id, no: index + 1 })}>
                                            <FaPen className="text-primary" size={10} />
                                          </button>
                                          <input type="radio" name="handheldPriceType" checked={isLineDefaultPriceType(11, priceType.id)} onChange={() => handlePriceTypeChange(model.id, 11, priceType.id)} />
                                        </div>
                                      </div>
                                      <table className="table table-hover table-bordered">
                                        <thead className="table-primary">
                                          <tr>
                                            <th width="50px">STT</th>
                                            <th><span data-note="KG">Khoảng</span></th>
                                            <th><span data-note="VNĐ">Giá</span></th>
                                            <th width="50px">
                                              <a onClick={() => openFeeEditor({ contactId: model.id, lineId: 11, type: 'kg', priceTypeId: priceType.id, no: model.handheldWeightFees.filter(item => item.priceTypeId === priceType.id).length + 1 })}><FaPlus /></a>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {model.handheldWeightFees && model.handheldWeightFees.filter(item => item.priceTypeId === priceType.id).map((item, index) => (
                                            <tr key={item.id}>
                                              <td>{index + 1}</td>
                                              <td>{item.start}-{item.end}</td>
                                              <td>{item?.fee?.toLocaleString("vi-VN")}</td>
                                              <td>{renderFeeActions({ itemId: item.id, no: index + 1 })}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  ))}
                                </div>



                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mt-4">
                          <div className="row">
                            <div className="col-12">
                              <div className="group-box p-2" data-text="Line sách tay: Hàng cồng kềnh">
                                <div className="subtitle bg-01">Bảng giá phổ thông</div>
                                <table className="table table-striped table-hover table-bordered">

                                  <thead className="table-primary">
                                    <tr>
                                      <th width="50px">STT</th>
                                      <th><span data-note="M3">Khoảng</span></th>
                                      <th><span data-note="VNĐ">Giá</span></th>
                                      <th width="50px">
                                        <a onClick={() => openFeeEditor({ contactId: model.id, lineId: 11, type: 'm3', no: model.handheldSizeFees.filter(item => !item.priceTypeId).length + 1 })}><FaPlus /></a>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {model.handheldSizeFees && model.handheldSizeFees.filter(item => !item.priceTypeId).map((item, index) => (
                                      <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td>{item.start}-{item.end}</td>
                                        <td>{item?.fee?.toLocaleString("vi-VN")}</td>
                                        <td>{renderFeeActions({ itemId: item.id, no: index + 1 })}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>

                                <div className="sub-price">
                                  {model.priceTypes && model.priceTypes.filter(item => item.lineId === 11).map((priceType, index) => (
                                    <div key={priceType.id}>
                                      <div className="subtitle">{priceType.name} <a className="link" onClick={() => openPriceTypeEditor({ id: priceType.id, no: index + 1 })}>...</a></div>
                                      <table className="table table-hover table-bordered">
                                        <thead className="table-primary">
                                          <tr>
                                            <th width="50px">STT</th>
                                            <th><span data-note="M3">Khoảng</span></th>
                                            <th><span data-note="VNĐ">Giá</span></th>
                                            <th width="50px">
                                              <a onClick={() => openFeeEditor({ contactId: model.id, lineId: 11, type: 'm3', priceTypeId: priceType.id, no: model.handheldSizeFees.filter(item => item.priceTypeId === priceType.id).length + 1 })}><FaPlus /></a>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {model.handheldSizeFees && model.handheldSizeFees.filter(item => item.priceTypeId === priceType.id).map((item, index) => (
                                            <tr key={item.id}>
                                              <td>{index + 1}</td>
                                              <td>{item.start}-{item.end}</td>
                                              <td>{item?.fee?.toLocaleString("vi-VN")}</td>
                                              <td>{renderFeeActions({ itemId: item.id, no: index + 1 })}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  ))}
                                </div>

                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12 mb-2">
                              {formWritable && (
                                <button type="button" className="small-btn" onClick={() => openPriceTypeEditor({ contactId: model.id, lineId: 11, no: getLinePriceTypes(11).length + 1 })}>Thêm bảng giá: Line XT</button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 form-item">
                        <div className="row mb-2">
                          <label className="form-label col-form-label col-sm-2 col-4 col-max174"><span data-note="Kg">Tối thiểu sách tay</span></label>
                          <div className="col-sm-2 col-8"><input name="name" placeholder="..." type="number" className="form-control" value={model.minWeightHandheld} onChange={(e) => setModel({ ...model, minWeightHandheld: e.target.value })} /></div>
                        </div>
                        <div className="row mb-2">
                          <label className="form-label col-form-label col-sm-2 col-4 col-max174">Địa chỉ kho sách tay</label>
                          <div className="col-sm-10 col-8"><textarea name="name" placeholder="Địa chỉ kho" type="text" className="form-control" value={model.addressHandheld} onChange={(e) => setModel({ ...model, addressHandheld: e.target.value })} ></textarea></div>
                        </div>
                        <div className="row">
                          <label className="form-label col-form-label col-sm-2 col-4 col-max174">Chính sách line sách tay</label>
                          <div className="col-sm-10 col-8"><textarea name="name" placeholder="Chính sách đền bù & mặt hàng không hỗ trợ" type="text" className="form-control" value={model.policyHandheld} onChange={(e) => setModel({ ...model, policyHandheld: e.target.value })}></textarea></div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/*12:Line vat*/}
                  {model.lineIds && model.lineIds.includes(12) && (

                    <div className="row">
                      <div className="col-md-6">
                        <div className="mt-4">
                          <div className="row">
                            <div className="col-12">
                              <div className="group-box p-2" data-text="Line chính ngạch: Hàng nặng">
                                <div className="subtitle bg-01 d-flex justify-content-between align-items-center">
                                  <span>Bảng giá phổ thông</span>
                                  <input type="radio" name="vatPriceType" checked={isLineDefaultPriceType(12, null)} onChange={() => handlePriceTypeChange(model.id, 12, null)} />
                                </div>
                                <table className="table table-striped table-hover table-bordered">

                                  <thead className="table-primary">
                                    <tr>
                                      <th width="50px">STT</th>
                                      <th><span data-note="KG">Khoảng</span></th>
                                      <th><span data-note="VNĐ">Giá</span></th>
                                      <th><span data-note="VNĐ">Phí đầu mục</span></th>
                                      <th><span data-note="%">Phí ủy thác</span></th>
                                      <th width="50px">
                                        <a onClick={() => openFee4Editor({ contactId: model.id, lineId: 12, type: 'kg', no: model.vatWeightFees.filter(item => !item.priceTypeId).length + 1 })}><FaPlus /></a>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {model.vatWeightFees && model.vatWeightFees.filter(item => !item.priceTypeId).map((item, index) => (
                                      <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td>{item.start}-{item.end}</td>
                                        <td>{item?.fee?.toLocaleString("vi-VN")}</td>
                                        <td>{item?.feeItem?.toLocaleString("vi-VN")}</td>
                                        <td>{item?.feeEntrust?.toLocaleString("vi-VN")}</td>
                                        <td>{renderFeeActions({ itemId: item.id, no: index + 1, vat: true })}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>

                                <div className="sub-price">
                                  {model.priceTypes && model.priceTypes.filter(item => item.lineId === 12).map((priceType, index) => (
                                    <div key={priceType.id}>
                                      <div className="subtitle d-flex justify-content-between align-items-center">
                                        <span>{priceType.name}</span>
                                        <div className="d-flex align-items-center">
                                          <button className="px-1 py-0 btn" onClick={() => openPriceTypeEditor({ id: priceType.id, no: index + 1 })}>
                                            <FaPen className="text-primary" size={10} />
                                          </button>
                                          <input type="radio" name="vatPriceType" checked={isLineDefaultPriceType(12, priceType.id)} onChange={() => handlePriceTypeChange(model.id, 12, priceType.id)} />
                                        </div>
                                      </div>
                                      <table className="table table-hover table-bordered">
                                        <thead className="table-primary">
                                          <tr>
                                            <th width="50px">STT</th>
                                            <th><span data-note="KG">Khoảng</span></th>
                                            <th><span data-note="VNĐ">Giá</span></th>
                                            <th><span data-note="VNĐ">Phí đầu mục</span></th>
                                            <th><span data-note="%">Phí ủy thác</span></th>
                                            <th width="50px">
                                              <a onClick={() => openFee4Editor({ contactId: model.id, lineId: 12, type: 'kg', priceTypeId: priceType.id, no: model.vatWeightFees.filter(item => item.priceTypeId === priceType.id).length + 1 })}><FaPlus /></a>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {model.vatWeightFees && model.vatWeightFees.filter(item => item.priceTypeId === priceType.id).map((item, index) => (
                                            <tr key={item.id}>
                                              <td>{index + 1}</td>
                                              <td>{item.start}-{item.end}</td>
                                              <td>{item?.fee?.toLocaleString("vi-VN")}</td>
                                              <td>{item?.feeItem?.toLocaleString("vi-VN")}</td>
                                              <td>{item?.feeEntrust?.toLocaleString("vi-VN")}</td>
                                              <td>{renderFeeActions({ itemId: item.id, no: index + 1, vat: true })}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  ))}
                                </div>



                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mt-4">
                          <div className="row">
                            <div className="col-12">
                              <div className="group-box p-2" data-text="Line chính ngạch: Hàng cồng kềnh">
                                <div className="subtitle bg-01">Bảng giá phổ thông</div>
                                <table className="table table-striped table-hover table-bordered">

                                  <thead className="table-primary">
                                    <tr>
                                      <th width="50px">STT</th>
                                      <th><span data-note="m3">Khoảng</span></th>
                                      <th><span data-note="vnđ">Giá</span></th>
                                      <th><span data-note="vnđ">Phí đầu mục</span></th>
                                      <th><span data-note="%">Phí ủy thác</span></th>
                                      <th width="50px">
                                        <a onClick={() => openFee4Editor({ contactId: model.id, lineId: 12, type: 'm3', no: model.vatSizeFees.filter(item => !item.priceTypeId).length + 1 })}><FaPlus /></a>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {model.vatSizeFees && model.vatSizeFees.filter(item => !item.priceTypeId).map((item, index) => (
                                      <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td>{item.start}-{item.end}</td>
                                        <td>{item?.fee?.toLocaleString("vi-VN")}</td>
                                        <td>{item?.feeItem?.toLocaleString("vi-VN")}</td>
                                        <td>{item?.feeEntrust?.toLocaleString("vi-VN")}</td>
                                        <td>{renderFeeActions({ itemId: item.id, no: index + 1, vat: true })}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>

                                <div className="sub-price">
                                  {model.priceTypes && model.priceTypes.filter(item => item.lineId === 12).map((priceType, index) => (
                                    <div key={priceType.id}>
                                      <div className="subtitle">{priceType.name} <a className="link" onClick={() => openPriceTypeEditor({ id: priceType.id, no: index + 1 })}>...</a></div>
                                      <table className="table table-hover table-bordered">
                                        <thead className="table-primary">
                                          <tr>
                                            <th width="50px">STT</th>
                                            <th><span data-note="m3">Khoảng</span></th>
                                            <th><span data-note="vnđ">Giá</span></th>
                                            <th><span data-note="vnđ">Phí đầu mục</span></th>
                                            <th><span data-note="%">Phí ủy thác</span></th>
                                            <th width="50px">
                                              <a onClick={() => openFee4Editor({ contactId: model.id, lineId: 12, type: 'm3', priceTypeId: priceType.id, no: model.vatSizeFees.filter(item => item.priceTypeId === priceType.id).length + 1 })}><FaPlus /></a>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {model.vatSizeFees && model.vatSizeFees.filter(item => item.priceTypeId === priceType.id).map((item, index) => (
                                            <tr key={item.id}>
                                              <td>{index + 1}</td>
                                              <td>{item.start}-{item.end}</td>
                                              <td>{item?.fee?.toLocaleString("vi-VN")}</td>
                                              <td>{item?.feeItem?.toLocaleString("vi-VN")}</td>
                                              <td>{item?.feeEntrust?.toLocaleString("vi-VN")}</td>
                                              <td>{renderFeeActions({ itemId: item.id, no: index + 1, vat: true })}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  ))}
                                </div>



                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12 mb-2">
                              {formWritable && (
                                <button type="button" className="small-btn" onClick={() => openPriceTypeEditor({ contactId: model.id, lineId: 12, no: getLinePriceTypes(12).length + 1 })}>Thêm bảng giá: Line vat</button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 form-item">
                        <div className="row mb-2">
                          <label className="form-label col-form-label col-sm-2 col-4 col-max174"><span data-note="Kg">Tối thiểu chính ngạch</span></label>
                          <div className="col-sm-2 col-8"><input name="name" placeholder="..." type="number" className="form-control" value={model.minWeightVat} onChange={(e) => setModel({ ...model, minWeightVat: e.target.value })} /></div>
                        </div>
                        <div className="row mb-2">
                          <label className="form-label col-form-label col-sm-2 col-4 col-max174">Địa chỉ kho chính ngạch</label>
                          <div className="col-sm-10 col-8"><textarea name="name" placeholder="Địa chỉ kho" type="text" className="form-control" value={model.addressVat} onChange={(e) => setModel({ ...model, addressVat: e.target.value })} ></textarea></div>
                        </div>
                        <div className="row">
                          <label className="form-label col-form-label col-sm-2 col-4 col-max174">Chính sách line chính ngạch</label>
                          <div className="col-sm-10 col-8"><textarea name="name" placeholder="Chính sách đền bù & mặt hàng không hỗ trợ" type="text" className="form-control" value={model.policyVat} onChange={(e) => setModel({ ...model, policyVat: e.target.value })}></textarea></div>
                        </div>
                      </div>
                    </div>
                  )}



                </div>

              </section>
            </div>
            <div>

            </div>

          </div>
        </div>
        <input type="hidden" id="list_lines" value="TMĐT,Line Thường,Line XT,Line VAT,Line TTH" />

        {feeEditorData && (
          <FeeEditor data={feeEditorData} handleSearch={searchFees} />
        )}
        {fee4EditorData && (
          <Fee4Editor data={fee4EditorData} handleSearch={searchFees} />
        )}
        {priceTypeData && (
          <PriceTypeEditor data={priceTypeData} handleSearch={searchFees} />
        )}

      </AdLayout>
    </div>
  );
};

export default Contact;
